<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('课程标题')" prop="title">
                <a-input v-model="queryParam.title" @pressEnter="handleQuery" :maxLength="64" :placeholder="$t('请输入')+$t('课程标题')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')+$t('状态')" allow-clear>
                  <a-select-option :value="20">{{ $t('上架') }}</a-select-option>
                  <a-select-option :value="10">{{ $t('下架') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageVisible = false">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(categoryTree)" v-hasPermi="['edu:course:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['edu:course:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1300 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="coverPic" slot-scope="text, record">
          <div>
            <img v-if="record.coverPic" :src="record.coverPic" style="width:60px;height:60px;" @click="handleRecordPreview(record.coverPic)" alt="coverPic"/>
          </div>
        </template>
        <span slot="isCharge" slot-scope="text, record">
          {{ record.isCharge ? $t('收费') : $t('免费') }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 20 ? 'green' : 'red'">{{ record.statusName }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, categoryTree)" v-hasPermi="['edu:course:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['edu:course:edit']" />
          <a @click="handleChangeStatus(record)" v-hasPermi="['edu:course:edit']">
            <a-icon :type="record.status === 20 ? 'download' : 'upload'" />{{ record.status === 20 ? $t('下架') : $t('上架') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['edu:course:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['edu:course:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageEduCourse, delEduCourse, changeEduCourseStatus } from '@/api/edu/course'
import { treeEduCategory } from '@/api/edu/category'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EduCourse',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      categoryTree: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      previewImageVisible: false,
      previewUrl: '',
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        title: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('课程标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('课程封面'),
          dataIndex: 'coverPic',
          scopedSlots: { customRender: 'coverPic' },
          align: 'center'
        },
        {
          title: this.$t('分类'),
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('收费'),
          dataIndex: 'isCharge',
          scopedSlots: { customRender: 'isCharge' },
          align: 'center'
        },
        {
          title: this.$t('价格'),
          dataIndex: 'price',
          align: 'center'
        },
        {
          title: this.$t('课时数'),
          dataIndex: 'lessonCount',
          align: 'center'
        },
        {
          title: this.$t('播放量'),
          dataIndex: 'playCount',
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '20%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
    this.getCategoryTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getCategoryTree () {
      treeEduCategory({}).then(response => {
        this.categoryTree = response.data || []
      })
    },
    /** 查询课程列表 */
    getList () {
      this.loading = true
      pageEduCourse(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        title: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 上下架 */
    handleChangeStatus (record) {
      const target = record.status === 20 ? 10 : 20
      const tip = target === 20 ? this.$t('确认上架该课程') : this.$t('确认下架该课程')
      var that = this
      this.$confirm({
        title: tip,
        onOk () {
          return changeEduCourseStatus({ id: record.id, status: target }).then(() => {
            that.getList()
            that.$message.success(that.$t('操作成功'), 3)
          })
        },
        onCancel () {}
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delEduCourse({ idList: that.ids })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('删除成功'), 3)
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>
